import React, { useState, useContext } from "react";
import { QuizContext } from "../../../assets/context/index";
import "./styled.css";

const questions = [
  {
    option: "a) Um Produto de Dados provido pelo time de ComOps Data Science.",
    correct: false,
  },
  {
    option:
      "b) Uma solução que utiliza de diferentes dados da Boehringer para gerar sugestões oportunas para os Consultores.",
    correct: false,
  },
  {
    option:
      "c) Colabora com a orquestração do Consultor, trazendo valor tangível para o Negócio e Nossos Clientes.",
    correct: false,
  },
  {
    option: "d) Todas as anteriores estão corretas",
    correct: true,
  },
];

export default function Question8(props) {
  const { t } = useContext(QuizContext);
  const { setQuestionSelected, checkAnswers } = props;
  const [optionSelected, setOptionSelected] = useState("");

  function selectOption(option) {
    setOptionSelected(option.option);

    setQuestionSelected((state) => {
      return {
        ...state,
        question8: {
          title: "O que é o Suggestions Next Best Action (NBA)?",
          option: option.option,
          correct: option.correct,
        },
      };
    });
  }
  return (
    <div style={{ marginTop: 30 }}>
      <h5 style={{ textAlign: "center" }}>
        O que é o Suggestions Next Best Action (NBA)?
      </h5>

      <div className="div-options-question-boe">
        {questions.map((e, i) => (
          <a
            key={i}
            className={`option-question-boe ${
              optionSelected === e.option && "selected-option-question-boe"
            } ${checkAnswers && (e.correct ? "check-true" : "check-false")}`}
            onClick={() => {
              if (!checkAnswers) {
                selectOption(e);
              }
            }}
          >
            {t(e.option)}
          </a>
        ))}
      </div>
    </div>
  );
}
